/*!
 * 
 *   @bornfight/gocart v1.0.9
 *   
 * 
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *	Add Multiple Triggers
 *   
 */


 class GoCart {

    constructor(options) {

        const defaults = {
            cartModalFail: '.js-go-cart-modal-fail',
            cartModalFailClose: '.js-go-cart-modal-fail-close',
            cartModal: '.js-go-cart-modal',
            cartModalClose: '.js-go-cart-modal-close',
            cartModalContent: '.js-go-cart-modal-content',
            cartModalItems: '.go-cart-item__single',
            cartDrawer: '.js-go-cart-drawer',
            cartDrawerContent: '.js-go-cart-drawer-content',
            cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
            cartDrawerFooter: '.js-go-cart-drawer-footer',
            cartDrawerClose: '.js-go-cart-drawer-close',
            cartMiniCart: '.js-go-cart-mini-cart',
            cartMiniCartContent: '.js-go-cart-mini-cart-content',
            cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
            cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
            cartTrigger: '.js-go-cart-trigger',
            cartOverlay: '.js-go-cart-overlay',
            cartCount: '.js-go-cart-counter',
            addToCart: '.js-go-cart-add-to-cart',
            removeFromCart: '.js-go-cart-remove-from-cart',
            removeFromCartNoDot: 'js-go-cart-remove-from-cart',
            itemQuantity: '.js-go-cart-quantity',
            itemQuantityPlus: '.js-go-cart-quantity-plus',
            itemQuantityMinus: '.js-go-cart-quantity-minus',
            cartMode: 'drawer',
            drawerDirection: 'right',
            displayModal: false,
            // eslint-disable-next-line no-template-curly-in-string
            moneyFormat: '${{amount}}',
            labelAddedToCart: 'was added to your cart.',
            labelCartIsEmpty: 'Your Cart is currently empty!',
            labelQuantity: 'Quantity:',
            labelRemove: 'Remove',
            hiddenItemTag: 'hidden-product',
        };

        this.defaults = Object.assign({}, defaults, options);

        this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
        this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
        this.cartModal = document.querySelector(this.defaults.cartModal);
        this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose);
        this.cartModalContent = document.querySelector(this.defaults.cartModalContent);
        this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
        this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent);
        this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
        this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter);
        this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose);
        this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
        this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent);
        this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
        this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
        this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
        this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
        // this.cartCount = document.querySelector(this.defaults.cartCount);
        this.cartCount = document.querySelectorAll(this.defaults.cartCount);
        this.addToCart = document.querySelectorAll(this.defaults.addToCart);
        this.removeFromCart = this.defaults.removeFromCart;
        this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
        this.itemQuantity = this.defaults.itemQuantity;
        this.itemQuantityPlus = this.defaults.itemQuantityPlus;
        this.itemQuantityMinus = this.defaults.itemQuantityMinus;
        this.cartMode = this.defaults.cartMode;
        this.drawerDirection = this.defaults.drawerDirection;
        this.displayModal = this.defaults.displayModal;
        this.moneyFormat = this.defaults.moneyFormat;
        this.labelAddedToCart = this.defaults.labelAddedToCart;
        this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
        this.labelQuantity = this.defaults.labelQuantity;
        this.labelRemove = this.defaults.labelRemove;
        this.hiddenItemTag = this.defaults.hiddenItemTag;

        this.init();

    }

    get isDrawerMode() {
        return this.cartMode === 'drawer';
    }

    init() {

        this.fetchCart();

        if (this.isDrawerMode) {
            this.setDrawerDirection();
        }

        /*
        document.addEventListener('click', (event) => {
            if (event.target.matches(this.defaults.addToCart)) {
                event.preventDefault();
                let item = event.target;
                let form = item.parentNode;
                while ('form' !== form.tagName.toLowerCase()) {
                    form = form.parentNode;
                }
                const formID = form.getAttribute('id');
                this.addItemToCart(formID);
            }
        }, false);
        */

        if (this.addToCart) { 
            this.addToCart.forEach((item) => {
                item.addEventListener('click', (event) => {
                  	
                    event.preventDefault();
                    let form = item.parentNode;
                    while ('form' !== form.tagName.toLowerCase()) {
                        form = form.parentNode;
                    }
                    const formID = form.getAttribute('id');
                    this.addItemToCart(formID);
                });
            });
        }

        this.cartTrigger.forEach((item) => {
            item.addEventListener('click', () => {
                if (this.isDrawerMode) {
                    this.openCartDrawer();
                } else {
                    this.openMiniCart();
                }
                this.openCartOverlay();
            });
        });


        this.cartOverlay.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

        if (this.isDrawerMode) {
            this.cartDrawerClose.addEventListener('click', () => {
                this.closeCartDrawer();
                this.closeCartOverlay();
            });
        }

        if (this.displayModal) {
            this.cartModalClose.forEach((item) => {
                item.addEventListener('click', () => {
                    this.closeFailModal();
                    this.closeCartModal();
                    if (this.isDrawerMode) {
                        this.closeCartDrawer();
                    } else {
                        this.closeMiniCart();
                    }
                    this.closeCartOverlay();
                });
            });
        }

        this.cartModalFailClose.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

    }

    fetchCart(callback) {
        window.fetch('/cart?view=json', {
            credentials: 'same-origin',
            method: 'GET',
        })
            .then((response) => response.text())
            .then((cart) => { eval(cart); this.fetchHandler(window.cart, callback)})
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    addItemToCart(formID) {
        const form = document.querySelector(`#${formID}`);
        const formData = serialize(form, {hash: true});

        // See go-cart.liquid
        // If this product has a max allowed quantity, make sure to add it to the variable where we track this information
        if (window.MaxQuantities) {
            const quantityInput = document.querySelector("#" + formID + " [name='quantity']");
            if (quantityInput) {
                // Get the max attribute
                const maxAttribute = quantityInput.attributes.max;

                // If the max attribute has a value
                if(maxAttribute && maxAttribute.value && maxAttribute.value != 0) {
                    // Track the maximum allowed quantity for the new product that was added to the cart
                    window.MaxQuantities.push({
                        "variantId": Number(formData.id),
                        "maxQuantity": maxAttribute.value
                    });
                }
            }
        }

        window.fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((product) => this.addItemToCartHandler(product))
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    removeItem(line) {
        const quantity = 0;
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    changeItemQuantity(line, quantity) {
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    changeMultipleItemsQuantity(data) {
        window.fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    cartItemCount(cart) {
        // this.cartCount.innerHTML = cart.item_count;
        this.cartCount.forEach((item) => {
            item.innerHTML = cart.item_count;
        });
    }

    fetchAndOpenCart() {
        this.fetchCart(() => {
            if (this.isDrawerMode) {
                this.openCartDrawer();
            } else {
                this.openMiniCart();
            }
            this.openCartOverlay();
        });
    }

    fetchAndOpenModal(product) {
        this.fetchCart(() => {
            this.renderCartModal(product);
            this.openCartModal();
            this.openCartOverlay();
        });
    }

    fetchHandler(cart, callback) {
        this.cartItemCount(cart);
        if (this.isDrawerMode) {
            if (cart.item_count === 0) {
                this.renderBlankCartDrawer();
                this.cartDrawerFooter.classList.add('is-invisible');
            } else {
                this.renderDrawerCart(cart);
                this.cartDrawerFooter.classList.remove('is-invisible');
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
            }
        } else if (cart.item_count === 0) {
            this.renderBlankMiniCart();
            this.cartMiniCartFooter.classList.add('is-invisible');
        } else {
            this.renderMiniCart(cart);
            this.cartMiniCartFooter.classList.remove('is-invisible');
            if ((typeof callback) === 'function') {
                callback(cart);
            }
        }

        this.checkShowMinicartRemovedGiftMessage();
    }

    addItemToCartHandler(product) {
        if (product && product.errors) {
            // Validation on add-to-cart failed.
            // Display messages:
            for (let key in product.errors) {
              if (product.errors.hasOwnProperty(key)) {
                    key = key.toLowerCase().replace(" ", "-");
                    let error = product.errors[key];

                    console.log({ key, error });

                    $(".error-message-" + key).text(error);
                  }
              }

              return;
          }
          else {
            $(".error-message").text("");
          }

      var cartItemVariantObj={};
      if (product.variant_options) {
        cartItemVariantObj = product.variant_options.map( function(variant){
          return variant;
        }); 
       }
        return this.displayModal ? this.fetchAndOpenModal(product) : this.fetchAndOpenCart();
    }

    ajaxRequestFail() {
        this.openFailModal();
        this.openCartOverlay();
    }

    renderCartModal(product) {
        this.clearCartModal();
        let productVariant = product.variant_title;
        if (productVariant === null) {
            productVariant = '';
        } else {
            productVariant = `(${productVariant})`;
        }
        const cartSingleProduct = `
          <div class="go-cart-modal-item">
            <div class="go-cart-item__image" style="background-image: url(${product.image});"></div>
            <div class="go-cart-item__info">
              ${product.product_title.includes(this.hiddenItemTag) ? 
              `<p class="go-cart-item__title">${product.product_title} ${productVariant}</p>` : 
              `<a href="${product.url}" class="go-cart-item__title h5">${product.product_title} ${productVariant}</a>`}
              ${this.labelAddedToCart}
            </div>
          </div>`;
        this.cartModalContent.innerHTML += cartSingleProduct;
    }

    renderDrawerCart(cart) {
        this.clearCartDrawer();
        var itmp = [];
        cart.items.forEach((item, index)=>{
          if (item.selling_plan_allocation) {
            item.lineNumber = Number(index+1);
            itmp.unshift(item);
          } else {
            item.lineNumber = Number(index+1);
            itmp.push(item);
          }
        });
        itmp.forEach((item, index) => {
            // See go-cart.liquid
            // When rendering the cart, make sure no items are above max quantity.
            // If they are, set them to the max quantity.
            // The customer shouldn't be able to increase a value past the max quantity.
            if (window.MaxQuantities) {
                var maxQuantityRecords = window.MaxQuantities.filter(function(maxQuantityItem) { return maxQuantityItem.productId == item.productId });

                if(maxQuantityRecords.length > 0) {
                    var maxQuantityRecord = maxQuantityRecords[0];

                    if(maxQuantityRecord.maxQuantity && item.quantity > maxQuantityRecord.maxQuantity) {
                        this.changeItemQuantity(item.lineNumber, maxQuantityRecord.maxQuantity > 0 ? maxQuantityRecord.maxQuantity : 0);
                    }
                }
            }

            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
            const properties = item.properties
            const bundleKey = Object.keys(properties).find(key => key === '_box_num');
            const freeProductBundleKey = Object.keys(properties).find(key => key === '_free_prod_num');
            const bundleNum = bundleKey ? properties[bundleKey] : undefined;

            let freeTiedProd = []
            if(bundleNum) {
                freeTiedProd =  itmp.filter(prod => {
                    const hasTiedProd = Object.keys(prod.properties).find(key => (key === '_free_prod_num' && prod.properties[key] === bundleNum));
                    if(hasTiedProd) {
                        return prod
                    }
                })
            }

            const cartSingleProduct = `
			  <div class="go-cart-item__single" data-line="${item.lineNumber}" data-brand="${ item.vendor }" data-id="${ item.id }" data-variant-id="${ item.variant_id }" data-price="${ (item.price / 100).toFixed(2) }" data-type="${ item.product_type }">
                <div class="go-cart-item__info-wrapper">
                  <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                  <div class="go-cart-item__info">
                    ${item.product_tags.includes(this.hiddenItemTag) ? 
                    `<p class="go-cart-item__title h4 color-charcoal">${item.product_title}</p>` : 
                    `<a href="${item.url}" class="go-cart-item__title h4 color-charcoal">${item.product_title}</a>`}
                    <div class="go-cart-item__variant body1">${itemVariant}</div>
                    <div class="go-cart-price-qty body1">
                      <div class="go-cart-item__price h4">${formatMoney(item.line_price, this.moneyFormat)}</div>
                      <div class="go-cart-item__quantity body1">
                        ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus" ${bundleNum && freeTiedProd.length > 0 ? `data-free-id="${freeTiedProd.map(pro => pro.variant_id).join(',')}"` : ``}>-</span>`}
                        <input class="go-cart-item__quantity-number js-go-cart-quantity body1" type="number" value="${item.quantity}" disabled>
                        ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus" style="${freeProductBundleKey ? 'pointer-events: none;' : ''}">+</span>`}
                      </div>
                    </div>
                  </div>
                </div>
                <a class="go-cart-item__remove ${this.removeFromCartNoDot}" ${bundleNum && freeTiedProd.length > 0 ? `data-free-id="${freeTiedProd.map(pro => pro.variant_id).join(',')}"` : ``}><i class="icon-remove cart-remove"></i></a>
              </div>`;
            this.cartDrawerContent.innerHTML += cartSingleProduct;
        });
        this.cartDrawerSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible');
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                if(item.getAttribute('data-free-id')) {
                    const v_id = item.parentNode.getAttribute('data-id');
                    const freeCartProd = item.getAttribute('data-free-id').split(",");
                    let obj = {};

                    obj[parseInt(v_id)] = 0;

                    freeCartProd.map(id => {
                        obj[parseInt(id)] = 0;
                    })

                    let formData = {
                        'updates': obj
                    };

                    if(freeCartProd) {
                        this.changeMultipleItemsQuantity(formData);
                        GoCart.removeItemAnimation(item.parentNode); 
                        freeCartProd.map(id => {
                           const cart = this.cartDrawerContent.querySelector(`[data-id="${id}"`)
                           GoCart.removeItemAnimation(cart);
                        });
                        
                        localStorage.setItem('show-removed-gift-minicart-msg', true);
                    }
                } else {
                    GoCart.removeItemAnimation(item.parentNode);
                    const line = item.parentNode.getAttribute('data-line');
                    this.removeItem(line);
                }
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const elementsToRemove = document.getElementsByClassName('max-quantity-message');
                for (let i = 0; i < elementsToRemove.length; i++) {
                    elementsToRemove[i].parentNode.removeChild(elementsToRemove[i]);
                }

                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const variantId = Number(item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-variant-id'));
                const currentQuantity = Number(item.parentNode.querySelector(this.itemQuantity).value);
                const newQuantity = currentQuantity + 1;
                let maxQuantity = null;
                
                if (window.MaxQuantities) {
                    // Look up the max quantity for this product
                    const results = window.MaxQuantities.filter(function(i) { return i.variantId == variantId; });

                    if(results.length > 0) {
                        const result = results[0];

                        maxQuantity = result.maxQuantity;
                    }
                }

                // Don't allow the customer to go over a certain quantity
                if(maxQuantity && currentQuantity >= maxQuantity) {
                    let maxQuantityMessage = document.createElement('p');
                    maxQuantityMessage.classList.add('max-quantity-message');
                    maxQuantityMessage.innerText = `Max Quantity of ${maxQuantity}`;
                    this.cartDrawerContent.prepend(maxQuantityMessage);
                    return;
                }

                this.changeItemQuantity(line, newQuantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const elementsToRemove = document.getElementsByClassName('max-quantity-message');
                for (let i = 0; i < elementsToRemove.length; i++) {
                    elementsToRemove[i].parentNode.removeChild(elementsToRemove[i]);
                }

                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;

                if(item.getAttribute('data-free-id')) {
                    const v_id = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-id');
                    const freeCartProd = item.getAttribute('data-free-id').split(",");
                    let obj = {};
                    
                    obj[parseInt(v_id)] = quantity;

                    freeCartProd.map(id => {
                        obj[parseInt(id)] = quantity;
                    });

                    let formData = {
                        'updates': obj
                    };

                    if(freeCartProd) {
                        this.changeMultipleItemsQuantity(formData);
                        GoCart.removeItemAnimation(item.parentNode);

                        freeCartProd.map(id => {
                            const cart = this.cartDrawerContent.querySelector(`[data-id="${id}"`);
                            GoCart.removeItemAnimation(cart);
                         });

                         localStorage.setItem('show-removed-gift-minicart-msg', true);
                    }
                    
                } else {
                    this.changeItemQuantity(line, quantity);
                }
          
          		// product info
          		const productName = item.parentNode.parentNode.parentNode.querySelector(".go-cart-item__title").innerText;
          		const brand = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-brand');
                const productID = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-id');
                const productPrice = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-price');
                const productType = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-type');
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
        this.updateShippingMotivator();
    }

    updateShippingMotivator() { 
        const freeShippingContainer = document.querySelector('.js-go-cart-drawer__shipping-message');
        if (freeShippingContainer.getAttribute("data-is-member")!="true" || freeShippingContainer.getAttribute("data-motivator-enabled")!="true") {
            freeShippingContainer.setAttribute("hidden","");
            return;
        }
        const cartTotal =  window.cart.items.reduce((a,b)=>{
            
                if (b.product_tags.includes("Member") || b.product_tags.includes("member")) {
                    return a+b.line_price
                } else {
                    return a
                }
            }
        ,0);
  
        if (freeShippingContainer) {
			const threshold = parseInt(freeShippingContainer.getAttribute('data-free-shipping-amount'));
			if ( cartTotal < threshold ) {
				document.querySelector('.go-cart-drawer__shipping-away').style.display = 'block';
				document.querySelector('.go-cart-drawer__shipping-meter').style.display = 'block';

				let leftAmount = threshold - cartTotal;
				let freeShippingAwayContainer = document.querySelector('.go-cart-drawer__shipping-away');
				let freeShippingAwayMessage = freeShippingAwayContainer.getAttribute('data-template');
				freeShippingAwayMessage = freeShippingAwayMessage.replace('##', `<strong>${formatMoney(leftAmount, this.moneyFormat)}</strong>`);
				freeShippingAwayContainer.innerHTML = freeShippingAwayMessage;

				leftAmount = parseInt(leftAmount * 100 / threshold);
				document.querySelector('.go-cart-drawer__shipping-fill').style.width = `${100 - leftAmount}%`;
				//document.querySelector('.go-cart-drawer__shipping-fill').innerHTML = `${100 - leftAmount}%`;
			} else { 
                let freeShippingAwayContainer = document.querySelector('.go-cart-drawer__shipping-away');
                freeShippingAwayContainer.innerHTML = freeShippingAwayContainer.getAttribute("data-threshold-met");
				document.querySelector('.go-cart-drawer__shipping-away').style.display = 'block';
				document.querySelector('.go-cart-drawer__shipping-meter').style.display = 'none';
			}
		}
	}
  
    renderMiniCart(cart) {
        this.clearMiniCart();
        cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
            const cartSingleProduct = `
              <div class="go-cart-item__single" data-line="${Number(index + 1)}">
                <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                    <div class="go-cart-item__info">
                        ${item.product_tags.includes(this.hiddenItemTag) ? 
                        `<p class="go-cart-item__title h3">${item.product_title}</p>` : 
                        `<a href="${item.url}" class="go-cart-item__title h3">${item.product_title}</a>`}
                        <div class="go-cart-item__variant">${itemVariant}</div>
                        <div class="go-cart-item__quantity">
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>`}
                          <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>`}
                        </div>
                    </div>
                </div>
                <div class="go-cart-item__price">${formatMoney(item.line_price, this.moneyFormat)}</div>
                <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>
              </div>`;
            this.cartMiniCartContent.innerHTML += cartSingleProduct;
        });
        this.cartMiniCartSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartMiniCartSubTotal.parentNode.classList.remove('is-invisible');
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                GoCart.removeItemAnimation(item.parentNode);
                const line = item.parentNode.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
    }

    renderBlankCartDrawer() {
        this.cartDrawerSubTotal.parentNode.classList.add('is-invisible');
        this.clearCartDrawer();
        this.cartDrawerContent.innerHTML = `<div class="go-cart__empty body1">${this.labelCartIsEmpty}</div>`;
        this.updateShippingMotivator();
    }

    renderBlankMiniCart() {
        this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible');
        this.clearMiniCart();
        this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty body1">${this.labelCartIsEmpty}</div>`;
    }

    reloadAjaxContent() {
      this.fetchAndOpenCart();
    }

    clearCartDrawer() {
        this.cartDrawerContent.innerHTML = '';
    }

    clearMiniCart() {
        this.cartMiniCartContent.innerHTML = '';
    }

    clearCartModal() {
        this.cartModalContent.innerHTML = '';
    }

    openCartDrawer() {
        this.cartDrawer.classList.add('is-open');
    }

    closeCartDrawer() {
        this.cartDrawer.classList.remove('is-open');
    }

    openMiniCart() {
        this.cartMiniCart.classList.add('is-open');
    }

    closeMiniCart() {
        this.cartMiniCart.classList.remove('is-open');
    }

    openFailModal() {
        this.cartModalFail.classList.add('is-open');
    }

    closeFailModal() {
        this.cartModalFail.classList.remove('is-open');
    }

    openCartModal() {
        this.cartModal.classList.add('is-open');
    }

    closeCartModal() {
        this.cartModal.classList.remove('is-open');
    }

    openCartOverlay() {
        this.cartOverlay.classList.add('is-open');
    }

    closeCartOverlay() {
        this.cartOverlay.classList.remove('is-open');
    }

    static removeItemAnimation(item) {
        item.classList.add('is-invisible');
    }

    setDrawerDirection() {
        this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
    }

    checkShowMinicartRemovedGiftMessage(){
        if(localStorage.getItem('show-removed-gift-minicart-msg')){
            let removedGiftP = document.createElement('p');
            removedGiftP.classList.add('minicart-removed-gift-msg');
            removedGiftP.innerText = this.cartDrawer.dataset.removedGiftMsgTranslation;
            this.cartDrawerContent.prepend(removedGiftP);
            localStorage.removeItem('show-removed-gift-minicart-msg');
        }
    }

}

//export default GoCart;